var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice-manager"},[_c('Card',{attrs:{"padding":10,"title":"菜单列表","shadow":""}},[_c('Table',{attrs:{"row-key":"id","columns":_vm.columns,"border":"","data":_vm.list,"stripe":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }